var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 92,
    viewBox: "0 0 156 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h110.006c25.148 0 45.534 20.386 45.534 45.534 0 25.147-20.386 45.533-45.534 45.533H0V0z",
    fill: "#925BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.299 68.56l-6.837-6.837 24.663-24.663 6.837 6.837z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.462 26.071l6.837-6.837 24.663 24.663-6.837 6.837z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.942 48.866v-9.791h38.272v9.79z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU2IiBoZWlnaHQ9IjkyIiB2aWV3Qm94PSIwIDAgMTU2IDkyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCAtNi4xMDM1MmUtMDVIMTEwLjAwNkMxMzUuMTU0IC02LjEwMzUyZS0wNSAxNTUuNTQgMjAuMzg2MSAxNTUuNTQgNDUuNTMzN0MxNTUuNTQgNzAuNjgxMyAxMzUuMTU0IDkxLjA2NzUgMTEwLjAwNiA5MS4wNjc1SDBWLTYuMTAzNTJlLTA1WiIgZmlsbD0iIzkyNUJGRiIvPgo8cmVjdCB4PSIxMTAuMjk5IiB5PSI2OC41NjAxIiB3aWR0aD0iOS42Njg1OSIgaGVpZ2h0PSIzNC44Nzg1IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDExMC4yOTkgNjguNTYwMSkiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjEwMy40NjIiIHk9IjI2LjA3MTQiIHdpZHRoPSI5LjY2ODU5IiBoZWlnaHQ9IjM0Ljg3ODUiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxMDMuNDYyIDI2LjA3MTQpIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSI5MS45NDI0IiB5PSI0OC44NjU0IiB3aWR0aD0iOS43OTA2IiBoZWlnaHQ9IjM4LjI3MjMiIHRyYW5zZm9ybT0icm90YXRlKC05MCA5MS45NDI0IDQ4Ljg2NTQpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrowMenu as ReactComponent };